<script setup lang="ts">
import { useFareOptimizerStore } from '@/store/fareOptimizer'
import { computed } from 'vue'
const store = useFareOptimizerStore()

const invoiceAlerts = computed(() => store.getInvoiceAlerts)
</script>

<template>
  <div v-if="invoiceAlerts.length > 0" class="mb-4 bg-red-400 p-4">
    <p class="mb-2 font-satoshi text-base font-bold text-white">Atenção! Foram encontradas inconsistências nos valores:</p>
    <ul class="list-disc pl-5">
      <li v-for="(alert, index) in invoiceAlerts" :key="index" class="mb-1 font-satoshi text-sm text-white">
        {{ alert }}
      </li>
    </ul>
  </div>
</template>
